// extracted by mini-css-extract-plugin
export default {"openFrequencies":"styles_openFrequencies__8UgIn"};